import { SpinWinActionTypes, SpinWinActions } from '../actions/spinWin.actions'

export interface Prize {
    label: string
    icon: string
    color: string
    title: string
    description: string
    code: string
}

export interface SpinWinState {
    prizes: Prize[]
    loading: boolean
    error: string | null
}

const initialState: SpinWinState = {
    prizes: [],
    loading: false,
    error: null
}

const spinWinReducer = (
    state: SpinWinState = initialState,
    action: SpinWinActions
): SpinWinState => {
    switch (action.type) {
        case SpinWinActionTypes.FETCH_PRIZES_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            }

        case SpinWinActionTypes.FETCH_PRIZES_SUCCESS:
            return {
                ...state,
                prizes: action.data,
                loading: false,
                error: null
            }

        case SpinWinActionTypes.FETCH_PRIZES_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error
            }

        default:
            return state
    }
}

export default spinWinReducer